import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const create_return_request = createAsyncThunk(
    'customerReturn/create',
    async (payload, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/return-requests', payload)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const get_my_return_requests = createAsyncThunk(
    'customerReturn/get_list',
    async ({ page = 1, limit = 10, status = 'all' } = {}, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/return-requests?page=${page}&limit=${limit}&status=${status}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const get_return_request = createAsyncThunk(
    'customerReturn/get_one',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/return-requests/${id}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const cancel_return_request = createAsyncThunk(
    'customerReturn/cancel',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/return-requests/${id}/cancel`)
            return fulfillWithValue({ ...data, id })
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

const returnSlice = createSlice({
    name: 'customerReturn',
    initialState: {
        returnRequests: [],
        totalReturns: 0,
        selectedReturn: null,
        successMessage: '',
        errorMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(create_return_request.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
            })
            .addCase(get_my_return_requests.fulfilled, (state, { payload }) => {
                state.returnRequests = payload.requests
                state.totalReturns = payload.total
            })
            .addCase(get_return_request.fulfilled, (state, { payload }) => {
                state.selectedReturn = payload.request
            })
            .addCase(cancel_return_request.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                state.returnRequests = state.returnRequests.map(r =>
                    r._id === payload.id ? { ...r, status: 'cancelled' } : r
                )
            })
            .addMatcher(
                (action) => action.type.startsWith('customerReturn/') && action.type.endsWith('/rejected'),
                (state, { payload }) => {
                    state.errorMessage = payload?.error || payload?.message || 'Something went wrong'
                }
            )
    }
})

export const { messageClear } = returnSlice.actions
export default returnSlice.reducer
